// Brand palettes. `primary` drives buttons, links, active states and the main chart series;
// `sidebar` is the sidebar background in light mode (dark mode uses `sidebarDark`).
export const PALETTES = {
  navy: {
    label: 'Navy & gold',
    primary: '#1F3C88',
    primaryHover: '#18306C',
    accent: '#D4A72C',
    sidebar: '#13213F',
    sidebarDark: '#0C1426',
  },
  slate: {
    label: 'Classic slate',
    primary: '#3B5BDB',
    primaryHover: '#2F4AB8',
    accent: '#F59F00',
    sidebar: '#3C4B64',
    sidebarDark: '#1E2533',
  },
  indigo: {
    label: 'Indigo',
    primary: '#4F46E5',
    primaryHover: '#4338CA',
    accent: '#06B6D4',
    sidebar: '#1E1B4B',
    sidebarDark: '#111027',
  },
  ocean: {
    label: 'Ocean teal',
    primary: '#0E7490',
    primaryHover: '#0B5D74',
    accent: '#F59E0B',
    sidebar: '#0B2530',
    sidebarDark: '#091519',
  },
  cedar: {
    label: 'Cedar green',
    primary: '#1F7A5A',
    primaryHover: '#18624A',
    accent: '#E8B04B',
    sidebar: '#0F2E25',
    sidebarDark: '#0B1714',
  },
  plum: {
    label: 'Plum',
    primary: '#8B3A8F',
    primaryHover: '#722F75',
    accent: '#F0A202',
    sidebar: '#2A1230',
    sidebarDark: '#170B1A',
  },
  terracotta: {
    label: 'Terracotta',
    primary: '#C2552D',
    primaryHover: '#A14524',
    accent: '#2A9D8F',
    sidebar: '#33190F',
    sidebarDark: '#1A0F0A',
  },
}

export const DEFAULT_PALETTE = 'navy'

/** Cedars campuses default to cedar green; every other campus to navy & gold. */
export const paletteForCampus = (branch) => ((branch?.slug || '').toUpperCase() === 'CEDARS' ? 'cedar' : 'navy')
export const DEFAULT_MODE = 'light'
